import { useQueryClient } from '@tanstack/react-query';

import { useMutation } from '@hooks/reactQuery';

import { useAppDispatch } from '@store/store';

import { setSnackbar } from '@slices/common';

import { updateAssetCartItem } from '@api/assetCartRequest';

import { handleErrorFromMessage } from '@utils/handleRequestError';

import { IResponseError } from '@interfaces/errors/apiErrors';
import { IHandleUpdateAssetCartItemDTO } from '@interfaces/rent/dto/assetCartDTO';

import { ESnackbarTypes } from '@enums/common';

import {
	ASSET_CART_REQUEST,
	ASSET_CART_REQUEST_COUNT,
	ASSET_CART_REQUEST_DROPDOWN,
} from '@constants/queryKeys';
import { responseMessages } from '@constants/responseMessages';

export const useMutateUpdateAssetCartItem = (onSuccessCallbacks?: Array<() => void>) => {
	const dispatch = useAppDispatch();
	const queryClient = useQueryClient();

	const {
		mutate: handleUpdateAssetCartItem,
		isLoading: isUpdatingAssetCartItem,
	} = useMutation<IHandleUpdateAssetCartItemDTO>({
		mutationKey: [ASSET_CART_REQUEST],
		mutationFn: updateAssetCartItem,
		onSuccess: () => {
			dispatch(setSnackbar({
				message: responseMessages.updateStartEndDate,
				type: ESnackbarTypes.success,
			}));

			if (onSuccessCallbacks?.length) {
				onSuccessCallbacks.forEach((callback) => callback());
			}

			return [
				queryClient.invalidateQueries([ASSET_CART_REQUEST]),
				queryClient.invalidateQueries([ASSET_CART_REQUEST_COUNT]),
				queryClient.invalidateQueries([ASSET_CART_REQUEST_DROPDOWN]),
			];
		},
		onError: (err: IResponseError) => handleErrorFromMessage(err),
	});

	return {
		handleUpdateAssetCartItem,
		isUpdatingAssetCartItem,
	};
};
